import { DevSettings } from '#settings/constants'
import { LegacyImport } from '#settings/dev.legacy'
import { LegacyAvlExternalImport } from '#settings/dev.legacy.avl.external'
import { LegacyAvlRavImport } from '#settings/dev.legacy.avl.rav'
import { toggles } from '#toggle/toggles'
import { useEnv } from 'apprise-frontend-core/env'
import { SettingRenderProps } from 'apprise-frontend-streams/settings/model'
import { Label } from 'apprise-ui/label/label'
import { MultiSelectBox } from 'apprise-ui/selectbox/selectbox'
import { Explainer, ExplainerPanel } from 'apprise-ui/utils/explainer'
import { Fragment } from 'react'
import { FaFlask } from 'react-icons/fa'


// the toggle picker (as dfad's Devtools), then the legacy imports.
// beta testers see the panel in production too, for the picker: the imports write records, so they stay out there.
export const DevSettingsPanel = (props: SettingRenderProps<DevSettings>) => {

    const { settings, onChange } = props

    const env = useEnv()

    const style ={padding: "10px 20px", background: 'rgb(220 226 231)', marginBottom: 30, marginTop: 20, borderRadius: 4}


    return <ExplainerPanel style={{padding:20}} >

        <Explainer framed title='Optional Features'>
            <p>
                By default, optional features are only enabled for beta testers.
                <br/>
                Pick below any feature that should be enabled for ALL users.
            </p>
            <MultiSelectBox
                options={[...toggles]}
                placeholder={"Select features to enable for all."}
                render={feat => <Label titleStyle={{ fontStyle: 'normal', textTransform: 'uppercase' }} icon={<FaFlask />} title={feat} />}
                onChange={toggledFeatures => onChange({ ...settings, enabledFeatures: toggledFeatures ?? [] })}>
                {settings.enabledFeatures}
            </MultiSelectBox>
        </Explainer>

        {env.name !== 'production' && <Fragment>

            <h2 style={style}>Import Vessels</h2>

            <LegacyImport />

            <br/>

            <h2 style={style}>Import AVL Declarations</h2>

            <LegacyAvlRavImport />

            <br/>

            <h2 style={style}>Import External AVL Declarations</h2>

            <LegacyAvlExternalImport />

        </Fragment>}

    </ExplainerPanel>

}
